// extracted by mini-css-extract-plugin
export default {"titleText":"titles-module__titleText___KQtb_","subTitleText":"titles-module__subTitleText___nyudZ"};